function escapeHtml(str) {
    if (!str)
        return '';
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}
export function showSearchModal(config) {
    const existing = document.querySelector('.search-modal-overlay');
    if (existing)
        existing.remove();
    const { title, dialogWidth, note, fields, columns, onSearch, onSelect } = config;
    const noteHtml = note ? `<p class="search-modal-placeholder">${escapeHtml(note)}</p>` : '';
    const overlay = document.createElement('div');
    overlay.className = 'search-modal-overlay';
    const modal = document.createElement('div');
    modal.className = 'search-modal-dialog';
    if (dialogWidth)
        modal.style.width = dialogWidth;
    // Header
    const header = document.createElement('div');
    header.className = 'search-modal-header';
    const titleEl = document.createElement('h3');
    titleEl.textContent = title;
    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'search-modal-close-btn';
    closeBtn.innerHTML = '<span class="material-icons">close</span>';
    header.appendChild(titleEl);
    header.appendChild(closeBtn);
    // Body
    const body = document.createElement('div');
    body.className = 'search-modal-body';
    // Search conditions
    const conditionsDiv = document.createElement('div');
    conditionsDiv.className = 'search-modal-conditions';
    fields.forEach(field => {
        const item = document.createElement('div');
        item.className = 'search-modal-field';
        const label = document.createElement('label');
        label.textContent = field.label;
        item.appendChild(label);
        if (field.type === 'select' && field.options) {
            const select = document.createElement('select');
            select.dataset.key = field.key;
            const emptyOpt = document.createElement('option');
            emptyOpt.value = '';
            emptyOpt.textContent = '選択してください';
            select.appendChild(emptyOpt);
            field.options.forEach(opt => {
                const option = document.createElement('option');
                option.value = opt.value;
                option.textContent = opt.label;
                select.appendChild(option);
            });
            if (field.defaultValue !== undefined)
                select.value = field.defaultValue;
            if (field.disabled)
                select.disabled = true;
            item.appendChild(select);
        }
        else {
            const input = document.createElement('input');
            input.type = 'text';
            input.dataset.key = field.key;
            input.placeholder = field.placeholder || '';
            item.appendChild(input);
        }
        conditionsDiv.appendChild(item);
    });
    const searchBtnDiv = document.createElement('div');
    searchBtnDiv.className = 'search-modal-search-actions';
    const searchBtn = document.createElement('button');
    searchBtn.type = 'button';
    searchBtn.className = 'search-modal-search-btn';
    searchBtn.innerHTML = '<span class="material-icons">search</span>検索';
    searchBtnDiv.appendChild(searchBtn);
    const resultsDiv = document.createElement('div');
    resultsDiv.className = 'search-modal-results';
    resultsDiv.innerHTML = '<p class="search-modal-placeholder">検索条件を入力して検索してください。</p>' + noteHtml;
    body.appendChild(conditionsDiv);
    body.appendChild(searchBtnDiv);
    body.appendChild(resultsDiv);
    // Footer
    const footer = document.createElement('div');
    footer.className = 'search-modal-footer';
    const cancelBtn = document.createElement('button');
    cancelBtn.type = 'button';
    cancelBtn.className = 'popup-btn popup-btn-close';
    cancelBtn.textContent = 'キャンセル';
    const confirmBtn = document.createElement('button');
    confirmBtn.type = 'button';
    confirmBtn.className = 'popup-btn popup-btn-confirm';
    confirmBtn.textContent = '確定';
    confirmBtn.disabled = true;
    footer.appendChild(cancelBtn);
    footer.appendChild(confirmBtn);
    modal.appendChild(header);
    modal.appendChild(body);
    modal.appendChild(footer);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    const MODAL_PAGE_SIZE = 100;
    let results = [];
    let selectedIndex = -1;
    let currentPage = 1;
    function renderResults() {
        if (results.length === 0) {
            resultsDiv.innerHTML = '<p class="search-modal-no-results">該当するデータがありません。</p>';
            confirmBtn.disabled = true;
            return;
        }
        const totalPages = Math.ceil(results.length / MODAL_PAGE_SIZE);
        if (currentPage > totalPages)
            currentPage = totalPages;
        const startIdx = (currentPage - 1) * MODAL_PAGE_SIZE;
        const pageItems = results.slice(startIdx, startIdx + MODAL_PAGE_SIZE);
        let html = '';
        if (results.length > MODAL_PAGE_SIZE) {
            html += '<div class="search-modal-paging">';
            html += `<span>${results.length}件中 ${startIdx + 1}～${startIdx + pageItems.length}件</span>`;
            html += `<button type="button" class="search-modal-page-btn" data-page="prev" ${currentPage <= 1 ? 'disabled' : ''}>`;
            html += '<span class="material-icons">chevron_left</span>前へ</button>';
            html += `<span>${currentPage} / ${totalPages}</span>`;
            html += `<button type="button" class="search-modal-page-btn" data-page="next" ${currentPage >= totalPages ? 'disabled' : ''}>`;
            html += '次へ<span class="material-icons">chevron_right</span></button>';
            html += '</div>';
        }
        html += '<table class="search-modal-table"><thead><tr><th class="search-modal-radio-cell"></th>';
        columns.forEach(col => {
            html += `<th${col.width ? ` style="width:${col.width}"` : ''}>${escapeHtml(col.label)}</th>`;
        });
        html += '</tr></thead><tbody>';
        pageItems.forEach((row, i) => {
            const globalIdx = startIdx + i;
            html += `<tr class="search-modal-row${globalIdx === selectedIndex ? ' selected' : ''}" data-index="${globalIdx}">`;
            html += `<td class="search-modal-radio-cell"><input type="radio" name="searchModalRadio" ${globalIdx === selectedIndex ? 'checked' : ''} /></td>`;
            columns.forEach(col => {
                html += `<td>${escapeHtml(row[col.key] || '')}</td>`;
            });
            html += '</tr>';
        });
        html += '</tbody></table>';
        resultsDiv.innerHTML = html;
        resultsDiv.querySelectorAll('.search-modal-row').forEach(row => {
            row.addEventListener('click', () => {
                selectedIndex = parseInt(row.dataset.index || '-1', 10);
                confirmBtn.disabled = false;
                renderResults();
            });
        });
        resultsDiv.querySelectorAll('.search-modal-page-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const dir = btn.dataset.page;
                if (dir === 'prev' && currentPage > 1)
                    currentPage--;
                if (dir === 'next' && currentPage < totalPages)
                    currentPage++;
                renderResults();
            });
        });
    }
    searchBtn.addEventListener('click', async () => {
        const conditions = {};
        conditionsDiv.querySelectorAll('[data-key]').forEach(el => {
            const key = el.dataset.key || '';
            conditions[key] = el.value;
        });
        const hasCondition = Object.values(conditions).some(v => v.trim() !== '');
        if (!hasCondition) {
            resultsDiv.innerHTML = '<p class="search-modal-placeholder">検索条件を1つ以上入力してください。</p>' + noteHtml;
            return;
        }
        searchBtn.disabled = true;
        searchBtn.textContent = '検索中...';
        try {
            results = await onSearch(conditions);
            selectedIndex = -1;
            currentPage = 1;
            confirmBtn.disabled = true;
            renderResults();
        }
        finally {
            searchBtn.disabled = false;
            searchBtn.innerHTML = '<span class="material-icons">search</span>検索';
        }
    });
    function close() {
        overlay.remove();
    }
    closeBtn.addEventListener('click', close);
    cancelBtn.addEventListener('click', close);
    overlay.addEventListener('click', (e) => {
        if (e.target === overlay)
            close();
    });
    confirmBtn.addEventListener('click', () => {
        if (selectedIndex >= 0 && results[selectedIndex]) {
            onSelect(results[selectedIndex]);
            close();
        }
    });
}
